import Modal from '@components/Modals/Interview';
import { useRestart } from '@hooks/utils/useRestart';
import type { MouseEventHandler } from 'react';
import { useState, type FC } from 'react';
import { Container, IconWrapper } from './style';
import SpeakerIcon from '/icon/refresh.svg';

const RestartToggle: FC = () => {
  const { executeRestart } = useRestart();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRoute = () => {
    setIsModalOpen(true);
  };

  const onConfirm: MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.stopPropagation();
    await executeRestart();
  };

  const onCancel: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setIsModalOpen(false);
  };

  return (
    <Container onClick={handleRoute}>
      <IconWrapper>
        <img src={SpeakerIcon} alt={'speaker'} />
      </IconWrapper>
      <span>재입장</span>
      {isModalOpen && (
        <Modal onClickConfirm={onConfirm} onClickCancel={onCancel}>
          면접 환경 체크 후 면접실로 입장할 수 있습니다.
          <br />
          재입장하시겠습니까?
        </Modal>
      )}
    </Container>
  );
};

export default RestartToggle;
